import * as IndicationActions from './indication-actions';
import * as IndicationReducer from './indication-reducer';

export {
    IndicationActions,
    IndicationReducer
};
